export const SectionIds = {
  SubscriptionPlan: 'SubscriptionPlan',
  Carriers: 'Carriers',
  Addons: 'Addons',
  Users: 'Users',
  AnalyticsLicenses: 'AnalyticsLicenses',
};

export const ActivationTiming = {
  IMMEDIATELY: 'Immediately',
  END_OF_BILLING_CYCLE: 'EndOfBillingCycle',
};

export const DEFAULT_USER_ADDON_PRICE = 5;
export const DEFAULT_ANALYTICS_LICENSE_ADDON_PRICE = 5;
export const DEFAULT_PREMIUM_ANALYTICS_LICENSE_ADDON_PRICE = 10;
